import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const INPUT_TYPE = {
  TEXT: 'text',
  PASSWORD: 'password'
};

const FRAGMENTS = {
  INPUT: '[data-fragment="ShowPassword.input"]'
};

export default class ShowPassword extends WebComponent {
  constructor(props) {
    super(props);

    this.objects = {};

    this.state = {
      isPasswordShow: false
    };

    this.handleClick = this.handleClick.bind(this);
  }

  didMount() {
    this.objects.inputElement = document.querySelector(FRAGMENTS.INPUT);

    this.on('click', this.handleClick);
  }

  update() {
    const {
      isPasswordShow
    } = this.state;

    if (isPasswordShow) {
      this.objects.inputElement.type = INPUT_TYPE.TEXT;
    } else {
      this.objects.inputElement.type = INPUT_TYPE.PASSWORD;
    }
  }

  handleClick() {
    const {
      isPasswordShow
    } = this.state;

    this.setState({
      isPasswordShow: !isPasswordShow
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ShowPassword.js